import Image from "next/image";

const WhatComponent = () => {
    return (
        <div className="overflow-hidden mt-[5rem] w-full h-auto md:h-[30rem] bg-primary text-[white] flex items-center justify-center child:flex child:items-center child:justify-center py-[5rem] px-[1rem] md:px-[15rem]">
            <div data-aos="fade-up" data-aos-duration="700" className="">
                <Image
                    src={"/icons/logo.svg"}
                    width={1000}
                    height={1000}
                    alt="logo"
                    className=" w-[5rem] md:w-[10rem]"
                />
                <Image
                    src={"/icons/bzaaarz-logo.svg"}
                    width={1000}
                    height={1000}
                    alt="logo"
                    className="w-[27rem] md:w-[40rem]"
                />
            </div>
            <Image
                data-aos="fade-left"
                width={1000}
                height={1000}
                alt="hero"
                className="w-[4rem] md:w-[7rem] -right-[2.5rem] bottom-[2.7rem] md:bottom-0 object-contain absolute"
                src="/icons/dots.svg"
            />
        </div>
    );
};

export default WhatComponent;
